import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { AddIcdCodeWebRequest, IcdCodeType } from '../../../../core/api/mhsConfigurationApiClient';
import { CodesService } from '../../services/codes-service';
import { NzDividerModule } from 'ng-zorro-antd/divider';

@Component({
  selector: 'app-icd-code-create',
  imports: [
    FormsModule,
    RouterLink,
    NzButtonModule,
    NzCardModule,
    NzCheckboxModule,
    NzFormModule,
    NzInputModule,
    NzIconModule,
    NzDividerModule,
  ],
  templateUrl: './icd-code-create.html',
  styleUrl: './icd-code-create.scss',
})
export class IcdCodeCreateComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly codesService = inject(CodesService);
  private readonly message = inject(NzMessageService);
  readonly type = this.route.snapshot.data['codeType'] as IcdCodeType;
  readonly title = this.type.replace('Icd', 'ICD-');
  readonly model = signal({ code: '', name: '', isVerified: false });
  readonly isSubmitting = signal(false);

  submit(): void {
    const value = this.model();
    if (!value.code.trim() || !value.name.trim()) return;
    this.isSubmitting.set(true);
    const request = new AddIcdCodeWebRequest({
      type: this.type,
      code: value.code.trim(),
      name: value.name.trim(),
      isVerified: String(value.isVerified),
    });
    this.codesService
      .create(request)
      .subscribe({
        next: () => {
          this.message.success(`Kod ${this.title} został dodany`);
          this.router.navigate(['/codes', this.type.toLowerCase()]);
        },
        error: (error) => console.error('Error creating ICD code:', error),
      })
      .add(() => this.isSubmitting.set(false));
  }
}
